import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template.jsx";

export default class FinanceCasesDetailDetails extends BaseRoute {
  @service("repositories/case-repository") caseRepository;
  @service("repositories/user-repository") userRepository;

  element = (<Template />);

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { _case: null, client: null };
    } else {
      try {
        const _case = await this.caseRepository.findRecord(id);
        const clientId = _case["client"]["id"];
        const client = await this.userRepository.findRecord(clientId);
        return { _case, client };
      } catch (error) {
        console.error(`Error getting case: ${id}`, error);
        return { _case: null, client: null };
      }
    }
  }
}
